import { createApp } from 'vue'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import $ from 'jquery'

// Foundation
import './assets/js/lib/foundation-explicit-pieces'

// Custom
import './assets/js/custom/browsers.js'
import './assets/js/custom/init-tables.js'
import './assets/js/custom/scroll-to.js'
import './assets/js/custom/site-overlay.js'
import './assets/js/custom/sticky.js'
import './assets/js/custom/menu.js'
import './assets/js/custom/tabs-dropdown.js'
import './assets/js/custom/toggler.js'
import './assets/js/custom/slider.js'
import './assets/js/custom/guided-tour-toggle.js'
import './assets/js/custom/o-video-player/setup.js'
import './assets/js/custom/form.js'
import './assets/js/custom/searchform-toggle.js'
import './assets/js/custom/flex-video.js'
import './assets/js/custom/pop-up-slide.js'

// import './assets/scss/app.scss';
import './assets/main.css'
import './assets/custom-bctg.css'

$(document).foundation()
// import './assets/scss/app.scss';

import AdultBasicEducationTransferSearchFiltersComponent from './components/AdultBasicEducationTransferSearchFiltersComponent.vue'
import AdultBasicEducationTransferSearchResultsComponent from './components/AdultBasicEducationTransferSearchResultsComponent.vue'

import AdvancedPlacementSearchFiltersComponent from './components/AdvancedPlacementSearchFiltersComponent.vue'
import AdvancedPlacementSearchResultsComponent from './components/AdvancedPlacementSearchResultsComponent.vue'

import BlockTransferSearchFiltersComponent from './components/BlockTransferSearchFiltersComponent.vue'
import BlockTransferSearchResultsComponent from './components/BlockTransferSearchResultsComponent.vue'

import CourseToCourseHomePageButtons from './components/CourseToCourseHomePageButtons.vue'
import CourseToCourseSearchFiltersComponent from './components/CourseToCourseSearchFiltersComponent.vue'
import CourseToCourseSearchResultsComponent from './components/CourseToCourseSearchResultsComponent.vue'

import DegreePartnershipsSearchFiltersComponent from './components/DegreePartnershipsSearchFiltersComponent.vue'
import DegreePartnershipsSearchResultsComponent from './components/DegreePartnershipsSearchResultsComponent.vue'

import EalSearchFiltersComponent from './components/EalSearchFiltersComponent.vue'
import EalSearchResultsComponent from './components/EalSearchResultsComponent.vue'

import InternationalBaccalaureateSearchFiltersComponent from './components/InternationalBaccalaureateSearchFiltersComponent.vue'
import InternationalBaccalaureateSearchResultsComponent from './components/InternationalBaccalaureateSearchResultsComponent.vue'

import MicroCredentialSearchComponent from './components/MicroCredentialSearchComponent.vue'

// Initialize Vue apps with API URLs
;(async () => {
  // Fetch API URLs once at startup
  let apiUrls = {}
  try {
    const response = await fetch('/wp-json/bctg/v1/api-urls')
    apiUrls = await response.json()
  } catch (error) {
    console.error('Failed to fetch API URLs:', error)
  }

  // Helper to spread API URLs as props
  const apiProps = {
    apiUrls,
  }

  // AdultBasicEducationTransferSearchFiltersComponent
  const ABESearchFiltersElement = document.getElementById('abe-search-filters')
  if (ABESearchFiltersElement) {
    const searchFiltersApp = createApp(AdultBasicEducationTransferSearchFiltersComponent, {
      nonce: ABESearchFiltersElement.getAttribute('nonce'),
      basePagePath: ABESearchFiltersElement.getAttribute('base-page-path'),
      resultsPagePath: ABESearchFiltersElement.getAttribute('results-page-path'),
      searchHeaderContent: ABESearchFiltersElement.getAttribute('search-header-content'),
      ...apiProps,
    })
    searchFiltersApp.mount('#abe-search-filters')
  }

  // AdultBasicEducationTransferSearchResultsComponent
  const ABESearchResultsElement = document.getElementById('abe-search-results')
  if (ABESearchResultsElement) {
    const searchResultsApp = createApp(AdultBasicEducationTransferSearchResultsComponent, {
      nonce: ABESearchResultsElement.getAttribute('nonce'),
      logosUrl: ABESearchResultsElement.getAttribute('logos-url'),
      ...apiProps,
    })
    searchResultsApp.mount('#abe-search-results')
  }

  // AdvancedPlacementSearchFiltersComponent
  const APSearchFiltersElement = document.getElementById('ap-search-filters')
  if (APSearchFiltersElement) {
    const searchFiltersApp = createApp(AdvancedPlacementSearchFiltersComponent, {
      nonce: APSearchFiltersElement.getAttribute('nonce'),
      basePagePath: APSearchFiltersElement.getAttribute('base-page-path'),
      resultsPagePath: APSearchFiltersElement.getAttribute('results-page-path'),
      searchHeaderContent: APSearchFiltersElement.getAttribute('search-header-content'),
      ...apiProps,
    })
    searchFiltersApp.mount('#ap-search-filters')
  }

  // AdvancedPlacementSearchResultsComponent
  const APSearchResultsElement = document.getElementById('ap-search-results')
  if (APSearchResultsElement) {
    const searchResultsApp = createApp(AdvancedPlacementSearchResultsComponent, {
      nonce: APSearchResultsElement.getAttribute('nonce'),
      logosUrl: APSearchResultsElement.getAttribute('logos-url'),
      ...apiProps,
    })
    searchResultsApp.mount('#ap-search-results')
  }

  // BlockTransferSearchFiltersComponent
  const BTSearchFiltersElement = document.getElementById('bt-search-filters')
  if (BTSearchFiltersElement) {
    const searchFiltersApp = createApp(BlockTransferSearchFiltersComponent, {
      nonce: BTSearchFiltersElement.getAttribute('nonce'),
      basePagePath: BTSearchFiltersElement.getAttribute('base-page-path'),
      resultsPagePath: BTSearchFiltersElement.getAttribute('results-page-path'),
      searchHeaderContent: BTSearchFiltersElement.getAttribute('search-header-content'),
      ...apiProps,
    })
    searchFiltersApp.mount('#bt-search-filters')
  }

  // BlockTransferSearchResultsComponent
  const BTSearchResultsElement = document.getElementById('bt-search-results')
  if (BTSearchResultsElement) {
    const searchResultsApp = createApp(BlockTransferSearchResultsComponent, {
      nonce: BTSearchResultsElement.getAttribute('nonce'),
      logosUrl: BTSearchResultsElement.getAttribute('logos-url'),
      ...apiProps,
    })
    searchResultsApp.mount('#bt-search-results')
  }

  // CourseToCourseHomePageButtons
  const C2CHomeFiltersElement = document.getElementById('c2c-home-filters')
  if (C2CHomeFiltersElement) {
    const searchFiltersApp = createApp(CourseToCourseHomePageButtons, {
      nonce: C2CHomeFiltersElement.getAttribute('nonce'),
      filtersPagePath: C2CHomeFiltersElement.getAttribute('filters-page-path'),
      ...apiProps,
    })
    searchFiltersApp.mount('#c2c-home-filters')
  }

  // CourseToCourseSearchFiltersComponent
  const C2CSearchFiltersElement = document.getElementById('c2c-search-filters')
  if (C2CSearchFiltersElement) {
    const searchFiltersApp = createApp(CourseToCourseSearchFiltersComponent, {
      nonce: C2CSearchFiltersElement.getAttribute('nonce'),
      basePagePath: C2CSearchFiltersElement.getAttribute('base-page-path'),
      resultsPagePath: C2CSearchFiltersElement.getAttribute('results-page-path'),
      shieldCheckIcon: C2CSearchFiltersElement.getAttribute('shield-check-icon'),
      ...apiProps,
    })
    searchFiltersApp.mount('#c2c-search-filters')
  }

  // CourseToCourseSearchResultsComponent
  const C2CSearchResultsElement = document.getElementById('c2c-search-results')
  if (C2CSearchResultsElement) {
    const searchResultsApp = createApp(CourseToCourseSearchResultsComponent, {
      nonce: C2CSearchResultsElement.getAttribute('nonce'),
      logosUrl: C2CSearchResultsElement.getAttribute('logos-url'),
      shieldCheckIcon: C2CSearchResultsElement.getAttribute('shield-check-icon'),
      wsEndpoint: C2CSearchResultsElement.getAttribute('ws-endpoint'),
      wsCustomEndpoint: C2CSearchResultsElement.getAttribute('ws-custom-endpoint'),
      ...apiProps,
    })
    searchResultsApp.mount('#c2c-search-results')
  }

  // DegreePartnershipsSearchFiltersComponent
  const DPSearchFiltersElement = document.getElementById('dp-search-filters')
  if (DPSearchFiltersElement) {
    const searchFiltersApp = createApp(DegreePartnershipsSearchFiltersComponent, {
      nonce: DPSearchFiltersElement.getAttribute('nonce'),
      basePagePath: DPSearchFiltersElement.getAttribute('base-page-path'),
      resultsPagePath: DPSearchFiltersElement.getAttribute('results-page-path'),
      searchHeaderContent: DPSearchFiltersElement.getAttribute('search-header-content'),
      ...apiProps,
    })
    searchFiltersApp.mount('#dp-search-filters')
  }

  // DegreePartnershipsSearchResultsComponent
  const DPSearchResultsElement = document.getElementById('dp-search-results')
  if (DPSearchResultsElement) {
    const searchResultsApp = createApp(DegreePartnershipsSearchResultsComponent, {
      nonce: DPSearchResultsElement.getAttribute('nonce'),
      logosUrl: DPSearchResultsElement.getAttribute('logos-url'),
      ...apiProps,
    })
    searchResultsApp.mount('#dp-search-results')
  }

  // EalSearchFiltersComponent
  const EALSearchFiltersElement = document.getElementById('eal-search-filters')
  if (EALSearchFiltersElement) {
    const searchFiltersApp = createApp(EalSearchFiltersComponent, {
      nonce: EALSearchFiltersElement.getAttribute('nonce'),
      basePagePath: EALSearchFiltersElement.getAttribute('base-page-path'),
      resultsPagePath: EALSearchFiltersElement.getAttribute('results-page-path'),
      searchHeaderContent: EALSearchFiltersElement.getAttribute('search-header-content'),
      ...apiProps,
    })
    searchFiltersApp.mount('#eal-search-filters')
  }

  // EalSearchResultsComponent
  const EALSearchResultsElement = document.getElementById('eal-search-results')
  if (EALSearchResultsElement) {
    const searchResultsApp = createApp(EalSearchResultsComponent, {
      nonce: EALSearchResultsElement.getAttribute('nonce'),
      logosUrl: EALSearchResultsElement.getAttribute('logos-url'),
      ...apiProps,
    })
    searchResultsApp.mount('#eal-search-results')
  }

  // InternationalBaccalaureateSearchFiltersComponent
  const IBSearchFiltersElement = document.getElementById('ib-search-filters')
  if (IBSearchFiltersElement) {
    const searchFiltersApp = createApp(InternationalBaccalaureateSearchFiltersComponent, {
      nonce: IBSearchFiltersElement.getAttribute('nonce'),
      basePagePath: IBSearchFiltersElement.getAttribute('base-page-path'),
      resultsPagePath: IBSearchFiltersElement.getAttribute('results-page-path'),
      searchHeaderContent: IBSearchFiltersElement.getAttribute('search-header-content'),
      ...apiProps,
    })
    searchFiltersApp.mount('#ib-search-filters')
  }

  // InternationalBaccalaureateSearchResultsComponent
  const IBSearchResultsElement = document.getElementById('ib-search-results')
  if (IBSearchResultsElement) {
    const searchResultsApp = createApp(InternationalBaccalaureateSearchResultsComponent, {
      nonce: IBSearchResultsElement.getAttribute('nonce'),
      logosUrl: IBSearchResultsElement.getAttribute('logos-url'),
      ...apiProps,
    })
    searchResultsApp.mount('#ib-search-results')
  }

  // MicroCredentialSearchComponent
  const MicroCredentialSearchElement = document.getElementById('micro-credential-search')
  if (MicroCredentialSearchElement) {
    const searchFiltersApp = createApp(MicroCredentialSearchComponent, {
      nonce: MicroCredentialSearchElement.getAttribute('nonce'),
      basePagePath: MicroCredentialSearchElement.getAttribute('base-page-path'),
      searchHeaderContent: MicroCredentialSearchElement.getAttribute('search-header-content'),
      logosUrl: MicroCredentialSearchElement.getAttribute('logos-url'),
    })
    searchFiltersApp.mount('#micro-credential-search')
  }
})()
